import { Outlet } from "react-router-dom";
import { twMerge } from "tailwind-merge";
import useOnlineStatus from "../hooks/useOnlineStatus";
import { useMenu } from "../stores/menu";
import NotificationToastContainer from "./NotificationToastContainer";
import OfflineWarning from "./OfflineWarning";
import Sidebar from "./Sidebar";
import useNewReleaseAvailable from "../hooks/useNewReleaseAvailable";
import NewReleaseAvailable from "./NewReleaseAvailable";

const Layout = () => {
  const { collapse } = useMenu();
  const { isOnline } = useOnlineStatus();
  const { hasNewReleaseNote } = useNewReleaseAvailable();

  return (
    <div className="flex flex-col h-screen">
      {!isOnline && <OfflineWarning />}
      {hasNewReleaseNote && <NewReleaseAvailable />}

      <div className={twMerge("flex", !isOnline && '-mt-9', hasNewReleaseNote && 'mt-9 max-h-[calc(100vh-36px)]')}>
        <Sidebar />

        <div className={twMerge("w-[calc(100vw-283px)] p-8", collapse && 'w-[calc(100vw-88px)]', !isOnline && 'mt-4 h-[calc(100vh-20px)]', hasNewReleaseNote && '-mt-2 h-[calc(100vh-36px)]')}>
          <Outlet />
        </div>
      </div>

      <NotificationToastContainer />
    </div>
  );
};

export default Layout;
